import Axios from '@/utils/axios'
import { formatDate } from '@/utils/formatter'

const URL = '/atestado'
const buildAtestado = params => {
  const formData = new FormData()
  formData.append('file', params.arquivo)
  formData.append('cids', JSON.stringify(params.cids))
  formData.append('beneficiario', params.beneficiario)
  formData.append('diasAfastamento', params.diasAfastamento)
  formData.append('documento', params.documento)
  formData.append('dtEmissao', `${formatDate(params.dtEmissao)} 00:00:00.000`)
  formData.append('nome', params.nome)
  formData.append('observacoes', params.observacoes)
  formData.append('tipo', params.tipo)
  formData.append('id', params.id)
  formData.append('arquivoAlterado', JSON.stringify({ value: !!params.arquivoAlterado }))
  return formData
}

export default {
  storeAtestado: async atestado => {
    return Axios.post(`${URL}`, buildAtestado(atestado))
  },
  updateAtestado: async atestado => {
    return Axios.put(`${URL}`, buildAtestado(atestado))
  },
  listarAtestados: async () => {
    return Axios.get(`${URL}`)
  },
  getAtestadoById: async idAtestado => {
    return Axios.get(`${URL}/${idAtestado}`)
  }
}
